module.exports = __webpack_public_path__ + "img/scanner_v3.47eb5df9.webp";